import { Head, useForm } from '@inertiajs/react';
import { LoaderCircle } from 'lucide-react';
import { FormEventHandler } from 'react';

import InputError from '../../components/input-error';
import TextLink from '../../components/text-link';
import { Button } from '../../components/ui/button';
import { Checkbox } from '../../components/ui/checkbox';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import AuthLayout from '../../layouts/auth-layout';
import useTranslation from '@backend/hooks/use-translation';

interface LoginForm {
    // email: string;
    username: string;
    password: string;
    remember: boolean;
}

interface LoginProps {
    status?: string;
    canResetPassword: boolean;
    game: any;
}

export default function Login({ status, canResetPassword, game }: LoginProps) {
    const { __ } = useTranslation();
    const { data, setData, post, processing, errors, reset } = useForm<LoginForm>({
        // email: '',
        username: '',
        password: '',
        remember: false,
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();
        post(route('login'), {
            onFinish: () => reset('password'),
        });
    };

    return (
        <AuthLayout title="Log in to your account" description="Enter your email and password below to log in">
            <Head title="Log in" />

            <form className="flex flex-col gap-6" onSubmit={submit}>
                <div className="grid gap-6">
                    <div className="auth-logo">
                    </div>
                    {/*<div className="grid gap-2">*/}
                    {/*    <Label htmlFor="email">{ __('Email address') }</Label>*/}
                    {/*    <Input*/}
                    {/*        id="email"*/}
                    {/*        type="email"*/}
                    {/*        required*/}
                    {/*        autoFocus*/}
                    {/*        tabIndex={1}*/}
                    {/*        autoComplete="email"*/}
                    {/*        value={data.email}*/}
                    {/*        onChange={(e) => setData('email', e.target.value)}*/}
                    {/*        placeholder={__('email@example.com') }*/}
                    {/*    />*/}
                    {/*    <InputError message={__(errors.email)} />*/}
                    {/*</div>*/}
                    <div className="grid gap-2">
                        <Label htmlFor="username">E-mailová adresa (pedagog) / číslo týmu (tým)</Label>
                        <Input
                            id="username"
                            type="text"
                            required
                            autoFocus
                            tabIndex={1}
                            autoComplete="username"
                            value={data.username}
                            onChange={(e) => setData('username', e.target.value)}
                            placeholder={__('')}
                        />
                        <InputError message={__(errors.username)} />
                    </div>

                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="password"> {__('Password')}</Label>
                            {canResetPassword && (
                                <TextLink href={route('password.request')} className="ml-auto text-sm" tabIndex={5}>
                                    {__('Forgot password?')}
                                </TextLink>
                            )}
                        </div>
                        <Input
                            id="password"
                            type="password"
                            required
                            tabIndex={2}
                            autoComplete="current-password"
                            value={data.password}
                            onChange={(e) => setData('password', e.target.value)}
                            placeholder={__('Password')}
                        />
                        <InputError message={__(errors.password)} />
                    </div>

                    <div className="flex items-center space-x-3">
                        <Checkbox id="remember" name="remember" tabIndex={3} />
                        <Label htmlFor="remember">{__('Remember me')}</Label>
                    </div>

                    <Button type="submit" className="mt-4 w-full" tabIndex={4} disabled={processing}>
                        {processing && <LoaderCircle className="h-4 w-4 animate-spin" />}
                        {__('Log in')}
                    </Button>
                </div>

                {game && (
                    <div className="text-muted-foreground space-x-1 text-center text-sm"><span>Jste pedagog a nemáte ještě účet?</span><br/>
                        <a href='/rocnik-2025/registrace' className={'text-foreground underline decoration-neutral-300 underline-offset-4 transition-colors duration-300 ease-out hover:decoration-current! dark:decoration-neutral-500'}>
                            Zaregistrujte se.
                        </a>
                    </div>
                )}

                {/*<div className="text-muted-foreground text-center text-sm">*/}
                {/*    Don't have an account?{' '}*/}
                {/*    <TextLink href={route('register')} tabIndex={5}>*/}
                {/*        Sign up*/}
                {/*    </TextLink>*/}
                {/*</div>*/}
            </form>

            {status && <div className="mb-4 text-center text-sm font-medium text-green-600">{__(status)}</div>}
        </AuthLayout>
    );
}
